import { getCookie } from "./cookie-helpers";

import { CookieName } from "@/shared/constants/enums";

export function getBearerToken(): string {
  const token = getCookie(CookieName.accessToken);

  return token ? `Bearer ${token}` : "Bearer ";
}
